<template>
  <div class="container page-con" style="display: flex;flex-direction: column;">
    <div class="container-top">
      <img style="height: 35px;width: 38px;" src="~assets/images/login_logo.png"/>
      <span>携船网业务管理系统</span>
      <Button class="btn" @click="goBack">返回</Button>
    </div>
    <img style="height: 400px;margin-top: 9px;" src="~assets/images/common/feedBackInfo.png"/>
    <div style="padding: 94px;box-sizing: border-box;background: #F6F7F8;height: 100%;">
      <div class="list-box common-shadow clearfix">
        <vxe-table
            class="table-style"
            highlight-hover-row
            show-footer
            show-overflow
            stripe
            align="center"
            border="none"
            max-height="350"
            :loading="loading"
            :data="tableData"
        >
          <vxe-table-column field="mobile" title="手机号">
            <template slot-scope="{ row }">
              <span>{{ row.mobile }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="content" title="投诉内容" show-overflow>
            <template slot-scope="{ row }">
              <span>{{ row.content }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="handleResult" title="处理结果" show-overflow>
            <template slot-scope="{ row }">
              <span>{{ row.handleResult }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="createTime" title="创建时间">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.createTime | timeFormat }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="handleTime" title="处理时间">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.handleTime | timeFormat }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>
<script>

  import $api from "@/apiProvider";

  export default {
    data() {
      return {
        loading: false,
        tableData: []
      }
    },
    mounted() {
      this.publicityFeedbackList();
    },
    methods: {
      goBack() {
        this.$router.push("/");
      },
      async publicityFeedbackList() {
        this.loading = true;
        let res = await $api.feedBack.get("publicityFeedbackList");
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      }
    }
  }
</script>
<style scoped>
  .container {
    background: #FFFFFF;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .container-top {
    padding: 12px 94px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 60px;
  }

  .container-top span {
    margin-left: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    line-height: 19px;
    color: #333333;
  }

  .btn {
    margin-left: auto;
    width: 68px;
    height: 28px;
    border: 1px solid #2D8CF0;
    opacity: 1;
    border-radius: 4px;
    font-size: 14px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    color: #2D8CF0;
  }
</style>